const IRIS_BANNER_SHOPZONE_REQUEST = 'IRIS_BANNER_SHOPZONE_REQUEST';
const IRIS_BANNER_SHOPZONE_SUCCESS = 'IRIS_BANNER_SHOPZONE_SUCCESS';
const IRIS_BANNER_SHOPZONE_ERROR = 'IRIS_BANNER_SHOPZONE_ERROR';

export default {
    IRIS_BANNER_SHOPZONE_REQUEST,
    IRIS_BANNER_SHOPZONE_SUCCESS,
    IRIS_BANNER_SHOPZONE_ERROR,
};
